// @ts-nocheck
import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdatePrice,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/ApplyPriceBreakDiscount";
import updatePriceBreakPrice from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdatePriceBreakPrice";

type HandlerType = HandlerWithResult<
    {
        index: number;
        calculationMethod: string;
        percent: number;
    },
    {
        priceWithDiscount: number;
    }
>;

export const StoreUpdatePrice: HandlerType = ({
    dispatch,
    getState,
    parameter: { index, calculationMethod, percent }, // Store Custom Code
    result: { priceWithDiscount },
}) => {
    updatePriceBreakPrice({ index, price: priceWithDiscount, calculationMethod, percent } as any)(dispatch, getState); // Store Custom Code
};

replaceInChain(chain, UpdatePrice, StoreUpdatePrice);
